import React, { createContext, useContext } from "react";
import { useAlertStream } from "@/hooks/useAlertStream";

const AlertStreamContext = createContext(null);

export function AlertStreamProvider({ children }) {
  const stream = useAlertStream([]);
  return <AlertStreamContext.Provider value={stream}>{children}</AlertStreamContext.Provider>;
}

export function useAlertStreamContext() {
  const ctx = useContext(AlertStreamContext);
  if (!ctx) {
    // Outside provider — return inert defaults so consumers don't crash.
    return { alerts: [], newAlertCount: 0, clearNew: () => {}, connectionStatus: "disconnected", lastNewAlertId: null };
  }
  return ctx;
}
